import { render, staticRenderFns } from "./DownloadDetail.vue?vue&type=template&id=37df124a&scoped=true&"
import script from "./DownloadDetail.vue?vue&type=script&lang=js&"
export * from "./DownloadDetail.vue?vue&type=script&lang=js&"
import style0 from "./DownloadDetail.vue?vue&type=style&index=0&id=37df124a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37df124a",
  null
  
)

export default component.exports